// extracted by mini-css-extract-plugin
export default {"logo":"kPRtQ42n2MdVEaAA_7_u"};